export default "<app-visit-list></app-visit-list>\r\n";